import styled from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import type { RdPos } from './groups';

const Pos = styled.span`
  white-space: nowrap;
`;

/** Восстановленная «Поз.» — с подсказкой, как прочитано. */
const Restored = styled(Pos)`
  border-bottom: 1px dotted ${({ theme }) => theme.colors.text.secondary};
  cursor: help;
`;

/** Марка, тип, артикул или обозначение строки — второй строкой. */
const Mark = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
  margin-top: 2px;
  overflow-wrap: anywhere;
`;

interface Props {
  position: PtoVolumePosition;
  /** «Поз.» РД строки ([`rdPositions`]); нет — у строки номера РД нет. */
  pos: RdPos | undefined;
}

/** Графа «Шифр» (вопрос 10 инженера, вариант «б»): «Поз.» РД — номер строки в
 *  таблице РД («1.1», «5»; склеенный OCR номер восстановлен по порядку в группе,
 *  прочитанное — в подсказке). Ниже — графа обозначения строки РД («Тип, марка,
 *  обозначение», «Обозначение»): шифр изделия не теряется. Графа позиции с
 *  маркой («КП-1», «Зд1») — марка, как раньше. */
export function CodeCell({ position: p, pos }: Props) {
  const designation = p.designation?.trim() || null;
  const head = pos ? (
    pos.read ? (
      <Restored
        title={`Поз. по РД; OCR прочитал «${pos.read}», номер восстановлен по порядку в группе`}
      >
        {pos.pos}
      </Restored>
    ) : (
      <Pos title="Поз. по РД">{pos.pos}</Pos>
    )
  ) : (
    p.code?.trim() || null
  );
  if (!head && !designation) return <>—</>;
  // Обозначение, равное шифру в первой строке (марка «ФЭ-1» в обоих полях), не
  // повторяем.
  const mark = designation !== head ? designation : null;
  return (
    <>
      {head}
      {mark && <Mark>{mark}</Mark>}
    </>
  );
}
